module.exports = __webpack_public_path__ + "build/img/keyboard.6b1f52e1.png";